// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__ox2ut","chapterId":"style__chapterId__5-OWj","chapterTitle":"style__chapterTitle__nvJic","logo":"style__logo__eCQGf"};